import { GroupuiHeadline, GroupuiText } from '@group-ui/group-ui-react';
import type { ReactNode } from 'react';

interface ErrorLayoutProps {
  headline: ReactNode;
  message: ReactNode;
  children: ReactNode;
}

/**
 * Provides a consistent layout for all pages related to errors
 * This layout consists of a header and a section for the pages content.
 * @param title Title of the page
 * @param headline Headline of the page
 * @param message Message of the page
 * @param children Content of the page
 * @returns {ReactNode} Returns a React element which renders a layout for the error pages.
 */
export function ErrorLayout({
  headline,
  message,
  children
}: Readonly<ErrorLayoutProps>): ReactNode {
  return (
    <div className='flex size-full items-center justify-center px-300 py-400 md:px-600 md:py-800'>
      <div
        className='flex flex-col gap-200 items-center justify-center'
        role='alert'
      >
        <div className='flex flex-col gap-100 items-center'>
          <GroupuiHeadline heading='h1' fontVariant='TheGroupHEAD-Light'>
            {headline}
          </GroupuiHeadline>

          <GroupuiText className='text-center max-w-xl'>{message}</GroupuiText>
        </div>

        {children}
      </div>
    </div>
  );
}
